import {useState} from "react";
import {BlueprintDialog} from "./Blueprints.js";
import LocalLoader from "../Loaders/LocalLoader";

export function CreateCodeFilePrompt({ fileItemToCreate, handleClose, handleBlueprintSelect, isFullscreen, setFullscreen }) {
    const [blueprintOpened, setBlueprintOpened] = useState(true);
    const [loading, setLoading] = useState(false);
    // return Folder/file
    const file = fileItemToCreate?.Key.split('/').slice(-2).join('/')
    if (!fileItemToCreate) return;

    if (loading) return <LocalLoader open={true} />

    if (blueprintOpened) {
        return <BlueprintDialog
            {...{isFullscreen, setFullscreen, file}}
            open={blueprintOpened}
            onClose={(...args) => {
                handleClose(...args)
                setBlueprintOpened(false);
            }}
            onCreate={async (...args) => {
                setLoading(true)
                await handleBlueprintSelect(...args)
                setLoading(false)
            }}
        />
    }

    setBlueprintOpened(true);

    return false;

}
